import { Pipe, PipeTransform } from '@angular/core';
import NiboWhatsAppConnection from './models/nibo-whatsapp-connection';

@Pipe({
  standalone: false,
  name: 'searchConnection'
})
export class SearchConnectionPipe implements PipeTransform {

  transform(value: NiboWhatsAppConnection[], arg: string): NiboWhatsAppConnection[] {
    const lowerArg = arg?.trim().toLowerCase();

    if (!lowerArg) {
      return value;
    }

    return value.filter(connection => {
      const connectionIdMatch = connection.connectionId?.toLowerCase().includes(lowerArg);
      const phoneNumberMatch = connection.connection?.phoneNumber?.toLowerCase().includes(lowerArg);
      const pushNameMatch = connection.connection?.pushName?.toLowerCase().includes(lowerArg);
      const labelMatch = connection.stringifiedLabels?.toLowerCase().includes(lowerArg);

      return connectionIdMatch || phoneNumberMatch || pushNameMatch || labelMatch;
    });
  }
}
